import { type TypeAccordionTriggerProps } from "./AccordionTypes";
import { AccordionTriggerHybrid } from "./AccordionTriggerHybrid";

/**
 * AccordionTrigger. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
export const AccordionTrigger = (props: TypeAccordionTriggerProps) => (
  <AccordionTriggerHybrid {...props} />
);
